import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { uniqBy, maxBy, minBy } from 'lodash'
import { getDate } from '../../../utils/DateUtil'
import DtoPickupOperation from '../../dto/DtoPickupOperation'
import DtoAnalysis from '../../dto/DtoAnalysis'
import { connect } from 'react-redux'
import { getPlurialWithNumber } from '../../../utils/StringUtils'
import i18n from 'simple-react-i18n'

class IndicatorQualitometer extends Component {
	getEndingDate = (list) => {
		return this.getDateByMinOrMax(list, maxBy)
	}

	getBeginningDate = (list) => {
		return this.getDateByMinOrMax(list, minBy)
	}

	getDateByMinOrMax = (list, filter) => {
		let result = filter(list, (o) => {
			return o.date
		})
		if (result) {
			return getDate(result.date)
		}
		return ''
	}

	getNbChimicalAnalysis = () => {
		return this.props.analysis.length
	}

	getNbOperation = () => {
		return this.props.pickupOperations.length
	}

	getNbParameterAnalysed = () => {
		if (this.props.analysis.length > 0) {
			const parameters = uniqBy(this.props.analysis, (analyse) => {
				return analyse.parameters
			})
			return parameters.length
		}
		return 0
	}

	render() {
		const valueNbOperation = this.getNbOperation()
		const valueNbChimicalAnalysis = this.getNbChimicalAnalysis()
		const valueNbParameters = this.getNbParameterAnalysed()
		return (
			<div className='row primary-light white-text no-margin'>
				<div className='col l12'><h5>{ i18n.quality } : { this.getBeginningDate(this.props.pickupOperations) } -
					{ this.getEndingDate(this.props.pickupOperations) } -
					{ valueNbOperation } { getPlurialWithNumber(i18n.lowerOperation, i18n.lowerOperations, valueNbOperation) }
					- { valueNbChimicalAnalysis } { getPlurialWithNumber(i18n.lowerAnalysis, i18n.lowerAnalyses, valueNbChimicalAnalysis) }
					- { valueNbParameters } { getPlurialWithNumber(i18n.lowerParameter, i18n.lowerParameters, valueNbParameters) }</h5></div>
			</div>
		)
	}
}

IndicatorQualitometer.propTypes = {
	pickupOperations: PropTypes.arrayOf(PropTypes.objectOf(DtoPickupOperation)),
	analysis: PropTypes.arrayOf(PropTypes.objectOf(DtoAnalysis))
}

IndicatorQualitometer.defaultProps = {
	pickupOperations: [],
	analysis: []
}

const mapStateToProps = store => {
	return {
		pickupOperations: store.DetailStationReducer.pickupOperations,
		analysis: store.DetailStationReducer.analysis
	}
}

export default connect(mapStateToProps)(IndicatorQualitometer)



// WEBPACK FOOTER //
// ./src/station/components/indicator/IndicatorQualitometer.js